import { BffApiService } from '#services/bffApi.service';
import {
  type FilterDefinitionValueSearchType,
  type GetFDVByFilterDefinitionIdResponse,
  type ProductTaxonomies,
  type StorePerimeters
} from '@carrefour-gcs/bff-sdk';

type FilterDefinitionValueRequestParamsType = {
  filterDefinitionId: string;
  taxonomy: ProductTaxonomies;
  storePerimeter: StorePerimeters;
  searchType?: FilterDefinitionValueSearchType;
  searchFilterValue?: string[];
  page?: number;
  pageSize?: number;
  withCount?: boolean;
};

/**
 * Requests the values of a filter definition through the POST search route. The search, the pagination
 * and the count option travel in the body, so a pasted list of hundreds of codes is not bounded by the URL length.
 */
export async function requestFilterDefinitionValues({
  filterDefinitionId,
  ...searchFDVBody
}: FilterDefinitionValueRequestParamsType): Promise<GetFDVByFilterDefinitionIdResponse> {
  const { data } = await BffApiService.instance.FilterDefinitionValue.searchFilterDefinitionValues({
    filterDefinitionId,
    searchFDVBody
  });

  return data;
}
